import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import VinColorField from "../components/VinColorField";
import {
  EXTERIOR_COLORS,
  INTERIOR_COLORS,
} from "../constants/vehicleColors";
import { isDevWizardHelpersEnabled } from "./CreateListingWizard/listingWizardDevFill";
import "./CreateListingWizard/CreateListingWizard.css";

/**
 * Local-only visual smoke page for VIN color UX (no auth / API required).
 * Available only when NODE_ENV=development.
 */
const DevVinColorSmoke: React.FC = () => {
  const [exteriorColor, setExteriorColor] = useState("Midnight Black Metallic");
  const [interiorColor, setInteriorColor] = useState("Graphite w/Gunmetal Fabric");
  const [darkMode, setDarkMode] = useState(true);

  if (!isDevWizardHelpersEnabled()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={`wizard-container ${darkMode ? "dark" : ""}`} style={{ minHeight: "100vh", padding: 24 }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <h1 style={{ fontSize: 22, margin: 0 }}>VIN color UX smoke</h1>
          <button
            type="button"
            className="wizard-btn wizard-btn-secondary"
            onClick={() => setDarkMode((v) => !v)}
          >
            {darkMode ? "Light" : "Dark"}
          </button>
        </div>
        <p style={{ color: darkMode ? "#aaa" : "#555", marginBottom: 24 }}>
          OEM manufacturer names stay out of the generic color dropdown.
        </p>
        <div className="details-grid">
          <VinColorField
            id="exteriorColor"
            label="Exterior Color"
            value={exteriorColor}
            suggestedColor="Midnight Black Metallic"
            options={EXTERIOR_COLORS}
            onChange={setExteriorColor}
            darkMode={darkMode}
          />
          <VinColorField
            id="interiorColor"
            label="Interior Color"
            value={interiorColor}
            suggestedColor="Graphite w/Gunmetal Fabric"
            options={INTERIOR_COLORS}
            onChange={setInteriorColor}
            darkMode={darkMode}
          />
        </div>
        <div style={{ marginTop: 24, fontSize: 13, color: darkMode ? "#888" : "#666" }}>
          Selected: exterior={exteriorColor || "(empty)"} · interior={interiorColor || "(empty)"}
        </div>
      </div>
    </div>
  );
};

export default DevVinColorSmoke;
